import { PrintRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import UNIVERSAL from "config";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import ReactLoading from "react-loading";
import useFormatter from "hooks/useFormatter";

const Profile = ({ profile, loading }) => {
  const { formatDate } = useFormatter();

  const site_logo = useSelector((state) => state?.base?.site_info?.site_logo);
  let curentCurrencySymbol = profile?.currency_symbol;

  const uni_table_columns = [
    { id: "semester", label: "Semester Name" },
    { id: "university_commission_amount", label: "Amount" },
    { id: "university_commission_date", label: "Date" },
    { id: "university_commission_due_date", label: "Due Date" },
    { id: "university_commission_status", label: "Status" },
  ];

  const uni_table_rows = profile?.university_commissions || [];
  const symbol = profile?.symbol;

  const printableContentRef = useRef();

  // conditional useState
  const [uni_print, setUniPrint] = useState(true);

  return loading ? (
    <Box
      sx={{
        height: "calc(100vh - 162px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ReactLoading
        type="cylon"
        color="#405189"
        height={"85px"}
        width={"100px"}
      />
    </Box>
  ) : (
    <Box m="-20px">
      <ReactToPrint
        documentTitle={profile?.invoice_number}
        onBeforeGetContent={async () => {
          setUniPrint(true);
        }}
        onAfterPrint={async () => {
          setUniPrint(true);
        }}
        trigger={() => (
          <Button
            variant="outlined"
            startIcon={<PrintRounded />}
            sx={{
              position: "absolute",
              right: "20px",
              top: "20px",
            }}
          >
            Print
          </Button>
        )}
        content={() => printableContentRef.current}
      />
      <Box ref={printableContentRef} p={3}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: "10px",
            mb: "35px",
          }}
        >
          <img
            src={UNIVERSAL.BASEURL + site_logo}
            alt=""
            style={{
              maxHeight: "100px",
              maxWidth: "240px",
            }}
          />
        </Box>
        <Box sx={{ marginBottom: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography textTransform="uppercase">Student Id:</Typography>
              <Typography>{profile?.student_id}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography textTransform="uppercase">Reference Name:</Typography>
              <Typography>{profile?.reference_name}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography textTransform="uppercase">Course Name:</Typography>
              <Typography>{profile?.course_name}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography textTransform="uppercase">Customer Name:</Typography>
              <Typography> {profile?.customer_name}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography textTransform="uppercase">
                University Name:
              </Typography>
              <Typography> {profile?.university_name}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography textTransform="uppercase">Intake Name:</Typography>
              <Typography> {profile?.intake_name}</Typography>
            </Box>
          </Box>
        </Box>

        {uni_print === true && (
          <Box
            sx={{
              display: "grid",
              width: "100%",
            }}
          >
            <Box
              sx={{
                margin: "20px 0",
              }}
            >
              <TableContainer sx={{ mt: "0px" }}>
                <Table stickyHeader>
                  <TableBody>
                    <TableRow>
                      {uni_table_columns.map((column) => (
                        <TableCell
                          sx={{ fontWeight: "500" }}
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                    {uni_table_rows?.map((row) => {
                      return (
                        <TableRow hover role="checkbox" key={row.id}>
                          {uni_table_columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.id === "intake_name" ? (
                                  profile?.intake_name
                                ) : column.id === "semester" ? (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {`${value?.name} (${value?.year})`}
                                  </Typography>
                                ) : column.id ===
                                  "university_commission_status" ? (
                                  <Typography
                                    color={
                                      value === "paid" ? "#008000" : "#FF0000"
                                    }
                                    variant="body2"
                                    sx={{
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {value}
                                  </Typography>
                                ) : column.id ===
                                    "university_commission_date" ||
                                  column.id ===
                                    "university_commission_due_date" ? (
                                  <Typography variant="body2">
                                    {formatDate(value)}
                                  </Typography>
                                ) : column?.id ===
                                  "university_commission_amount" ? (
                                  curentCurrencySymbol + (value || 0)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box
              sx={{
                margin: "20px 0 0 auto",
                padding: "20px 30px",
                border: "1px solid #caddff",
                bgcolor: "#fbfcff",
                width: "300px",
                mt: "30px",
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "100px auto",
                }}
              >
                <Typography
                  align="right"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  Payble Amount
                </Typography>
                <Typography align="right">
                  {curentCurrencySymbol + profile?.payable}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "100px auto",
                }}
              >
                <Typography align="right">Due Amount</Typography>
                <Typography align="right">
                  {curentCurrencySymbol + profile?.due}
                </Typography>
              </Box>

              <Box
                sx={{
                  borderTop: "1px solid #cbcbcb",
                  display: "grid",
                  gridTemplateColumns: "100px auto",
                  pt: "5px",
                  mt: "5px",
                }}
              >
                <Typography align="right" fontSize="16px">
                  Total Paid
                </Typography>
                <Typography align="right" fontSize="16px">
                  {curentCurrencySymbol + profile?.paid}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Profile;
